import { render } from "./HeroPage.vue?vue&type=template&id=60275ece&scoped=true"
import script from "./HeroPage.vue?vue&type=script&lang=js"
export * from "./HeroPage.vue?vue&type=script&lang=js"

import "./HeroPage.vue?vue&type=style&index=0&id=60275ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60275ece"]])

export default __exports__